const map = require('lodash/fp/map');
const memoizer = require('../request-handler/utils/memoizer');

function parseResult(res) {
  if(!res){
    return null;
  }
  return JSON.stringify(res);
}

function serviceFactory({ api }) {
  const getStatus = memoizer()((inputParam, metaData) =>
    api.getStatus(inputParam, metaData)
    .then(parseResult)
    .catch((error) => {
      return null;
    })
  );

  return {
    getStatus,
  };

}

module.exports = serviceFactory;